export default {
  initialized: false,
  loading: false,
  sdk: {},
  error: false,
};
